import { useMemo } from 'react'
import { useAppSelector } from '../hooks'

/** 团队统计中本 hook 用到的字段 · 仅声明 totalNum（团队照片总数）*/
interface GroupStatistics {
  /** 团队照片总数 · 来自 state.group.statistics（与 Header 统计同源）*/
  totalNum: number
}

/** 格式化后的团队照片数 · 数值与单位拆开，渲染处自行拼接 */
export interface GroupPhotoNumFormatted {
  /** 数值 · < 1 万为原始整数；≥ 1 万为「万」单位、保留两位小数的字符串 */
  value: number | string
  /** 单位 · '张'（< 1 万）/ '万'（≥ 1 万）*/
  unit: '张' | '万'
}

/** 「万」进位阈值 · 与 Header NewStatistics 一致 */
const WAN = 10000

/**
 * 团队照片总数的格式化结果，与 Header `NewStatistics` 的 `photoNum.totalNum` 同源同算法。
 *
 * - 数据源：`state.group.statistics.totalNum`（团队照片总数）。
 * - 格式化：< 1 万直接显示原始整数，单位「张」；≥ 1 万除以 1 万、保留两位小数，单位「万」。
 *
 * 注：刻意复制 NewStatistics 的算法而非共用 —— 按约束「不改 NewStatistics 已有代码」。
 *
 * @returns 统计就绪时返回 {@link GroupPhotoNumFormatted}；statistics 未加载时返回 null。
 */
export function useGroupPhotoNumFormated(): GroupPhotoNumFormatted | null {
  const statistics = useAppSelector(
    (state: any) => state.group.statistics as GroupStatistics | null
  )

  return useMemo(() => {
    if (!statistics) return null
    const total = statistics.totalNum
    return {
      value: total < WAN ? total : (total / WAN).toFixed(2),
      unit: total < WAN ? '张' : '万'
    }
  }, [statistics])
}
